export const changePassword = async (user, password, newPassword) => {

    return new Promise((resolve, reject) => {
        user.changePassword(password, newPassword, (err, result) => {
          if (err) {
            return reject(err);
          }
          return resolve(result);
        });
      });
    }

export default changePassword;
